import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Modal from '~/commons/components/Modal.jsx';

const setPopCookie = (ann, modalPath) => {
  const name = `last.popped.ann.${modalPath}.${ann.popupFreq}`;
  const popped = Cookies.get(name);

  if (ann._id !== popped) {
    Cookies.set(name, ann._id, {
      expires: 365,
      sameSite: 'strict',
      secure: window.location.protocol === 'https:',

    });

    return true;
  }

  return false;
};

const ModalAnnouncement = ({ path = 'app' }) => {
  const [show, setShow] = useState(false);
  const [content, setContent] = useState(null);
  const [, req] = useHttpStatus({
    onSuccess({ data: { once, everyday } = {} }) {
      if (once && setPopCookie(once, path)) {
        setContent(once);
        setShow(true);
      } else if (everyday && setPopCookie(everyday, path)) {
        setContent(everyday);
        setShow(true);
      }
    },
  });
  useEffect(() => {
    req({
      url: '/api/site/announcements/popup',
    });
  }, []);

  if (!content) return '';

  const img = content.coverImg ? (
    <img className="w-100" src={content.coverImg} alt={content.title} />
  ) : (
    ''
  );

  return content ? (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      centered={path === 'app'}
      size="lg"
      className="p-0"
    >
      {path === 'app' ? (
        <Link
          to={`/app/announcements/${content._id}`}
          onClick={() => setShow(false)}
        >
          {img}
        </Link>
      ) : (
        <a
          href={`/announcements/${content._id}`}
          onClick={() => setShow(false)}
        >
          {img}
        </a>
      )}
    </Modal>
  ) : (
    ''
  );
};

export default ModalAnnouncement;
